<div *ngIf="displaySaveCancelActions" class="navigation-items action-items">
  <div class="action-icon" (click)="saveCancelActions('cancelTenantDataChanges')">
    <svg-icon src='./assets/icons/close-outline.svg' class="menu-action-icon svg-icon-gray"
              title="{{'projectToolbar.cancel' | translate | uppercase}}" align='center'></svg-icon>
    <div class="icon-label icon-label-vertical-alignment">{{'projectToolbar.cancel' | translate | uppercase}}</div>
  </div>
</div>
